module.exports = __webpack_public_path__ + "img/RORBPJR40009.3c4f0e3a.png";